import React from 'react';

const teamMembers = [
    {
        name: 'dau Sharan Agarwal',
        title: 'Founder & CEO',
        image: './Dau sharan.jpeg',
        description: `Dau Sharan Agarwal is a dedicated entrepreneur with a strong passion for creating comfortable and well-managed paying guest accommodations. With many years of hands-on experience in the PG and residential housing domain, he has developed a deep understanding of what residents truly need to feel safe, cared for, and at home.

        His journey has been shaped by years of managing properties, maintaining high living standards, and building trusted relationships with students and working professionals. Dau Sharan Agarwal believes that successful paying guest living goes beyond providing rooms—it’s about delivering reliability, cleanliness, and a sense of belonging.
        
        As the founder of the paying guest accommodation, he brings together experience, personal involvement, and a resident-first mindset to ensure every home reflects comfort, trust, and quality living.`,

    },
    {
        name: 'harshit Agarwals',
        title: 'Founder & CEO',
        image: './harshit.jpeg',
        description: `Harshit Agarwal serves as Senior Director and Head of Gujarat Operations, bringing years of experience in overseeing and managing paying guest accommodations across the region. With a strong focus on operational excellence, quality standards, and resident satisfaction, he ensures smooth day-to-day functioning of all properties. His leadership is driven by a commitment to maintaining clean, comfortable, and well-managed living spaces while continuously improving the overall PG experience in Gujarat.`,

    },
    {
        name: 'Nayan Agarwal',
        title: 'Director of Noida Housing',
        image: './nayan_pic.JPG',
        description: `Nayan Agarwal serves as Director and Head of Noida Operations brings years of hands-on experience in managing paying guest accommodations, with dedication, care, and attention to detail in everyday operations. His journey has been shaped by a passion for maintaining a clean, comfortable, and well-organized home.`,
        linkedIn: 'https://www.linkedin.com/in/nayan-agarwal-72449018a',
    },
];

const TeamSection = () => {
    return (
        <div className="container my-5 mobile-view-container" style={{ paddingLeft: "120px", paddingRight: "120px" }}>
            <h2 className="text-center mb-4 fw-bold">Say Hello To The Leaders Of Our Team!</h2>
            <p className="text-center text-muted mb-5">
                Our guiding pillars who support us in everything we do.
            </p>
            <div className="row">
                {teamMembers.map((member, index) => (
                    <div key={index} className="col-12 mb-4">
                        <div className="d-flex gap-4 align-items-center mobile-view-about-us">
                            <img
                                src={member.image}
                                alt={member.name}
                                className="rounded shadow-sm"
                                style={{
                                    width: member.name === "Radhika Mitra" ? "280px" : '300px', height: member.name === "Radhika Mitra" ? "280px" : '300px', objectFit: 'cover'
                                }}
                            />
                            <div>
                                <p style={{ whiteSpace: 'pre-line', fontSize: "16px", color: "#000", fontWeight: "500", textAlign: "left" }}>{member.description}</p>
                                {member.linkedIn && <a href={member.linkedIn} className="text-danger fw-bold" target="_blank">
                                    Visit LinkedIn
                                </a>}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};


export default TeamSection;
